module.exports={
    "emailSubject": "Upgrade TractIQ Access",
    "emailBody": "I'd like to upgrade my organization to TractIQ Pro. Please let me know what the next steps are.",
    "upgradeToPro": "Upgrade to Pro for Access",
    "contactUs": "Contact us"
}